// redux/wholesaler/ThunkAction.ts

import { createAsyncThunk } from "@reduxjs/toolkit";
import { iStateMessage } from "@/customTypes/GenericReduxTypes";
import { iGenericResponse } from "@/customTypes/CommonServiceTypes";
import { curryGetThunkName } from "@/projectUtils/ReduxUtil";
import { httpStatusCodes } from "@/customTypes/NetworkTypes";
import { verifywholesalerservice} from "@/services/api/cresivoxServer";
import { REDUCER_NAME } from "./Types";


const curriedGetThunkName = curryGetThunkName(REDUCER_NAME);

// Verify Wholesaler Thunk
export const verifyWholesaler = createAsyncThunk<
  iGenericResponse<any | null> | null,
  { userId: string; isVerified: boolean },
  {
    rejectValue: iStateMessage;
  }
>(
  curriedGetThunkName("verifyWholesaler"),
  // @ts-expect-error: Type mismatch between expected types
  async ({ userId, isVerified }, { rejectWithValue }) => {
    try {
      const response = await verifywholesalerservice.verifyWholesaler
      (userId, { isVerified });
      
      if (response) {
        const { httpStatusCode, data, message } = response;

        switch (httpStatusCode) {
          case httpStatusCodes.SUCCESS_OK: {
            if (data && data.data) {
              return {
                httpStatusCode,
                data: data.data,
                message,
              };
            } else {
              return rejectWithValue({
                httpStatusCode,
                message,
              });
            }
          }
          default: {
            return rejectWithValue({
              httpStatusCode,
              message,
            });
          }
        }
      } else {
        return rejectWithValue({
          message: "No response received",
        });
      }
    } catch (error) {
      return rejectWithValue({
        message: "Something went wrong",
      });
    }
  }
);
